const getEnv = (key, fallback = "") => {
  return (
    (typeof process !== "undefined" && process?.env && process?.env[key]) ||
    fallback
  );
};

const config = {
  api: {
    baseUrl: getEnv("REACT_APP_API_URL"),
  },

  images: {
    cacheUrl: getEnv("REACT_APP_IMAGE_CACHE_URL"),
    baseUrl: getEnv("REACT_APP_IMAGE_BASE_URL"),
  },

  app: {
    env: getEnv("REACT_APP_ENVIRONMENT", "development"),
  },
};

export default config;
